import { EmptyState } from '@ntconsult/aluma-react';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { i18nKeyForError } from '../utils/errors';

type NoIdentityStateProps = {
  code: string;
};

/**
 * `403 NO_AXIIS_IDENTITY` e variantes (`05-spec-sessao-back.md` §4) não são
 * erro de formulário — substituem a página inteira (`07-spec-front.md` §7).
 */
export function NoIdentityState({ code }: NoIdentityStateProps) {
  const { t } = useTranslation('alocacao');
  return (
    <div className="grid min-h-[60vh] place-items-center p-6">
      <EmptyState
        decorator={<ShieldAlert size={32} aria-hidden />}
        title={t(i18nKeyForError(code) as never)}
        description={t('erros.noAxiisIdentityGuidance')}
      />
    </div>
  );
}
